module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row padding-top-50px"
  }, _vm._l((_vm.loggedUser.businessLines), function(row) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-3 col-lg-2 padding-top-10px",
      attrs: {
        "offset": _vm.index > 0 ? 2 : 0
      }
    }, [_c('RenderImagem', {
      attrs: {
        "height": "height: 200px;",
        "router": {
          name: 'SystemsList',
          params: {
            businessAreaId: row.id
          }
        },
        "label": row.labelPt,
        "src": _vm.getLogo(row.id)
      }
    })], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a5947fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/businessArea/components/BusinessAreaList.vue
// module id = 879
// module chunks = 2